export default __webpack_public_path__ + "static/media/210430-Cloudxier Clients Logo-22.f81a77d8.png";